<template>
  <tr>
    <template v-if="columns.length > 0 && !isExternal">
      <td v-for="(item, index) in list" :key="index">
        {{ item.info || $t('message.generics.message.notInformed') }}
      </td>

      <td>
        <i
          class="mdi mdi-laptop"
          v-tooltip="`MAC's do usuário`"
          @click="showingMacsModal = true"
        ></i>
        <i
          v-if="isAdminAndIsNotLoggedAs"
          class=" mdi mdi-delete"
          v-tooltip.auto="$t('message.generics.message.exclude')"
          @click="pendingRemove = item.id"></i>
      </td>
    </template>
    <template v-else>
       <td>
        {{ name }}
      </td>

      <td>
        {{gender}}
      </td>

      <td>
        {{ birthdate }}
      </td>

      <td>
        {{email}}
      </td>

      <td>
        {{phoneNumber}}
      </td>

    </template>

    <app-confirmation-modal :value="!!pendingRemove"
                            :confirm-label="$t('message.generics.message.confirm')"
                            @confirm="confirmRemove"
                            @cancel="pendingRemove = null">
      <span slot="heading">
        {{$t('message.generics.message.excludeClient')}}
      </span>
      <span>
        {{$t('message.generics.message.confirmExclusion')}}
      </span>
    </app-confirmation-modal>


    <modal v-if="showingMacsModal" v-model="showingMacsModal">
        <template #header>
            <div class="macs-modal-header">
                <b>{{ name }}</b>
                <app-search @enter="(value) => searchMac = value" class="search" />
            </div>
        </template>

        <LeadsMacsList :client="item" :search="searchMac" :key="searchMac" />

    </modal>
  </tr>
</template>

<script>
import tableItem from "@mixins/table-item";
import Case from "case";
import AppConfirmationModal from "@components/ConfirmationModal";
import EventBus from "../../../packages/event-bus";
import Modal from "@/components/generic/Modal";
import AppSearch from "@components/Search";
import LeadsMacsList from "./LeadsMacsList.vue";

export default {
  mixins: [tableItem],

  components: {
    AppConfirmationModal,
    Modal,
    AppSearch,
    LeadsMacsList
  },

  data() {
    return {
      showingMacsModal: false,
      pendingRemove: null,
      searchMac: ''
    }
  },
  props: {
    isExternal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    gender() {
      return Case.sentence(this.item.sexo || this.item.gender);
    },

    name() {
      return this.item.nome || this.item.name || this.$t('message.generics.message.notInformed');
    },

    birthdate() {
      const value = this.item.dataNascimento || this.item.birthDate;

      return value ? this.$date.format(value) : this.$t('message.generics.message.notInformed');
    },

    email() {
      return this.item.email || this.$t('message.generics.message.notInformed');
    },

    phoneNumber() {
      return this.item.telefone || this.item.phoneNumber || this.$t('message.generics.message.notInformed');
    },

    columns() {
      return this.isAdminAndIsNotLoggedAs ? this.$store.state.leads.columnsToShowAdmin  : this.$store.state.leads.columnsToShow
    },

    list() {
      const userExtraFieldsArray = this.item.extraFields ? JSON.parse(this.item.extraFields) : null

      const userExtraFieldsObj = userExtraFieldsArray ?  userExtraFieldsArray.reduce((resultado, objeto) => {
          const chave = Object.keys(objeto)[0];
          const valor = objeto[chave];

          resultado[chave] = valor;

          return resultado;
      }, {}) : null

      let array = []
      const userObject = userExtraFieldsObj ? Object.assign(this.item, userExtraFieldsObj) : this.item
      const userObjectKeys = Object.keys(userObject)
      this.columns.map(item => {
        if(item.showing) {
          if(userObjectKeys.includes(item.name)) {
            if(item.name === "dataNascimento") {

              array.push({info: userObject[item.name] ? this.$date.format(userObject[item.name]) : this.$t('message.generics.message.notInformed')})

            } else if (item.name === "sexo") {
              array.push({
                info: userObject[item.name] === "MASCULINO" ? this.$t('message.statistics.message.male') : userObject[item.name] === "FEMININO" ? this.$t('message.statistics.message.female') : this.$t('message.generics.message.notInformed')
              })
            } else {
              array.push({
                info: userObject[item.name] === "true" || userObject[item.name] === "false" ? userObject[item.name] === "true" ? this.$t('message.leads.message.true') : this.$t('message.leads.message.false')  : userObject[item.name]
              })
            }
          } else {
            array.push({
              info: this.$t('message.generics.message.notInformed')
            })
          }
        }
      })
      return array
    },
    isAdmin() {
      return this.$store.state.users.admin;
    },
    user() {
      return !!this.$store.state.users.user;
    },
    isAdminAndIsNotLoggedAs() {
      return (this.isAdmin && !this.user)
    },
    permissions() {
      return this.$store.state.users.user.permissions;
    },

    canManageConnections() {
        return !!this.permissions.find((x) => x === "MANAGE_CONNECTIONS")
    }
  },

  methods: {
    async confirmRemove() {
       await this.$api.leads.removeClient(this.pendingRemove);

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: "Cliente excluído com sucesso",
        timeout: 2000,
      });
      this.$store.commit("LEADS_RESET_FILTER");
      this.$emit('deleted')
      this.pendingRemove = null;
    },
  }
};
</script>

<style lang="scss" scoped>

.macs-modal-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search {
    width: 100%;
    max-width: fit-content;
}

.mdi {
  cursor: pointer;
  font-size: 20px;
}
</style>
